// import heroCarousel1 from '@/images/1.jpg'
import heroCarousel2 from '@/images/zdr.png'
// import heroCarousel4 from '@/images/4.jpg'

export const POST_DRAW_POLL_DEADLINE_GRACE_MS = 10 * 60 * 1000

export const redWaveNumbers = [
  '01', '02', '07', '08', '12', '13', '18', '19', '23', '24', '29', '30', '34', '35', '40', '45', '46'
]

export const blueWaveNumbers = [
  '03', '04', '09', '10', '14', '15', '20', '25', '26', '31', '36', '37', '41', '42', '47', '48'
]

export const greenWaveNumbers = [
  '05', '06', '11', '16', '17', '21', '22', '27', '28', '32', '33', '38', '39', '43', '44', '49'
]

export const waveTables = {
  red: redWaveNumbers,
  blue: blueWaveNumbers,
  green: greenWaveNumbers
}

export const defaults = {
  promoUrl: 'https://example.com',
  liveNote: '直播搅珠于北京时间 21:32 开始',
  stations: [
    { name: '49 彩票 - 集团站', url: 'https://0049.example' },
    { name: '49 彩票 - 备用线路', url: 'https://bk.example' }
  ],
  liveStreamUrl: ''
}

function sampleDraw(issue, nextIssue) {
  return {
    issue,
    nextIssue,
    nextTime: null,
    drawTimeFormatted: '',
    nextIssueDisplay: '',
    nextDrawDeadlineMs: null,
    mainNumbers: [
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' },
      { value: '', zodiac: '', element: '' }
    ],
    special: { value: '', zodiac: '', element: '' }
  }
}

export const heroSlides = [
  // { image: heroCarousel1, alt: '首页轮播图 1' },
  { image: heroCarousel2, alt: '首页轮播图 2' },
  // { image: heroCarousel4, alt: '首页轮播图 3' }
]

const bbsFilesBaseGames = [

]



const bbsFilesBackend = []


/**
 * 玩法前端配置映射（key = 后端返回的 code）
 * 仅存放有特殊配置的玩法，其他玩法自动使用默认配置
 */
export const gameConfigMap = {
  new_HK6: {
    pictureLotteryType: 3,
    bbsId: 1,
    bbsFiles: bbsFilesBaseGames
  },
  xbc: {
    bbsId: 4
  },
  macau: {
    drawSchedule: 'daily',
    liveStreamUrl: 'https://live-macaujc.com/live/livestream/new.m3u8',
    resultUrl: 'https://macaumarksix.com/api/live2',
    drawPageType: 'MACAU',
    pictureLotteryType: 2,
    drawRequest: {
      url: 'https://macaumarksix.com/api/macaujc2.com',
      method: 'get',
      params: { type: 'MACAU' }
    }
  },
  hk: {
    drawSchedule: 'hk246',
    resultUrl: '/api/hk-lot-draws/getHKLotteryResult',
    drawPageType: 'hk',
    pictureLotteryType: 1,
    drawRequest: {
      url: '/api/hk-lot-draws/getHKLotteryResult',
      method: 'get',
      params: {}
    }
  }
}

/**
 * 固定基础玩法（始终显示，不从后端获取）
 */
export const baseGames = [
  {
    id: 'macau',
    label: '新澳六合彩',
    drawSchedule: 'daily',
    liveStreamUrl: 'https://live-macaujc.com/live/livestream/new.m3u8',
    resultUrl: 'https://macaumarksix.com/api/live2',
    pictureLotteryType: 2,
    bbsId: 1,
    bbsFiles: bbsFilesBaseGames,
    drawRequest: {
      url: 'https://macaumarksix.com/api/macaujc2.com',
      method: 'get',
      params: { type: 'MACAU' }
    },
    draw: sampleDraw(112, 113)
  },
  {
    id: 'hk',
    label: '香港六合彩',
    drawSchedule: 'hk246',
    resultUrl: '/api/hk-lot-draws/getHKLotteryResult',
    pictureLotteryType: 1,
    drawRequest: {
      url: '/api/hk-lot-draws/getHKLotteryResult',
      method: 'get',
      params: {}
    },
    draw: sampleDraw(48, 49)
  }
]

export const GAME_ID_TO_DRAW_TYPE = {
  new_HK6: 'new_HK6',
  xbc: 'xbc',
  macau: 'MACAU',
  hk: 'hk',
  'hk-new': 'new_HK6'
}

export function makeGameFromBackend(item) {
  const cfg = gameConfigMap[item.code] || {}
  return {
    id: item.code,
    label: item.nameCn || item.code,
    lotteryTypeId: item.id,
    drawSchedule: cfg.drawSchedule || 'daily',
    resultUrl: cfg.resultUrl || '/api/live',
    useOpenTimeAsDeadline: cfg.useOpenTimeAsDeadline !== undefined ? cfg.useOpenTimeAsDeadline : true,
    drawPageType: cfg.drawPageType || item.code,
    pictureLotteryType: cfg.pictureLotteryType != null ? cfg.pictureLotteryType : null,
    liveStreamUrl: cfg.liveStreamUrl || '',
    bbsId: cfg.bbsId || 4,
    bbsFiles: cfg.bbsFiles || bbsFilesBackend,
    drawRequest: cfg.drawRequest || {
      url: '/api/live',
      method: 'get',
      params: { code: item.code }
    },
    draw: sampleDraw(0, 0)
  }
}

/**
 * 根据后端玩法列表追加到基础玩法后面
 * @param {Array} backendList - 后端返回的 list
 * @returns {Array} games 数组（baseGames + 后端追加的）
 */
export function buildGames(backendList) {
  const base = JSON.parse(JSON.stringify(baseGames))
  if (!Array.isArray(backendList) || backendList.length === 0) return base
  const existingIds = new Set(base.map(g => g.id))
  for (let i = backendList.length - 1; i >= 0; i--) {
    const item = backendList[i]
    if (!existingIds.has(item.code)) {
      base.splice(1, 0, makeGameFromBackend(item))
      existingIds.add(item.code)
    }
  }
  return base
}
